/** 门店物资类型API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/store/materialType';
/**
 * 分页查询门店物资类型
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.MaterialType> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询门店物资类型列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.MaterialType> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个门店物资类型
 *
 * @param id 门店物资类型ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.MaterialType> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存门店物资类型
 *
 * @param params 门店物资类型信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新门店物资类型信息
 *
 * @param params 门店物资类型信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除门店物资类型
 *
 * @param id 门店物资类型ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除门店物资类型
 *
 * @param ids 门店物资类型ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
